import React, {useState, useEffect} from 'react';
import { useNavigate, } from 'react-router-dom';
import { Form, Row, Col, Card, } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';

import HabilitationService from 'services/habilitationsService';
import { Axios } from 'helpers/axios';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formMotDePasseClient } from 'helpers/yupValidationSchema';

const InitPassword = ({hasLabel = true, tokenInitMdp}) => {
    // MODAL
    const [isLoading, setIsLoading] = useState(false);
    const { handleSubmit, formState: { errors }, setValue, watch } = useForm({
        resolver: yupResolver(formMotDePasseClient),
    });
    
    const navigate = useNavigate();
    // Handler
    const definirMotDePasse = async (data) => {
        try {
            setIsLoading(true);
            
            const response = await Axios.post('/publicRoutes/setupPassword', {
                tokenInitMdp: tokenInitMdp,
                motDePasse: data.motDePasse,
            });

            if(!response.data.auth==true) {
                setIsLoading(false);
            }else{
                response.data.seSouvenir = window.__ENV__.LOGIN_REMEMBER_DEFAULT;
                HabilitationService.saveCompleteSet(response.data);
                navigate('/');
            }
        } catch (e) {
            setIsLoading(false);
            console.error(e);
        }
    };
    
    useEffect(()=>{
        if(HabilitationService.token)
        {
            HabilitationService.disconnect();
        }
    },[])

    return (<>

        <Card >
            <Card.Body>
                <p className="text-center">
                    <h4><b>Espace Client<br/>Nouveau mot de passe</b></h4>
                </p>
                <Form onSubmit={handleSubmit(definirMotDePasse)}>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Mon nouveau mot de passe</Form.Label>
                                <Form.Control
                                    placeholder={!hasLabel ? '*****' : ''}
                                    value={watch('motDePasse')}
                                    name="motDePasse"
                                    onChange={(e) => setValue('motDePasse', e.target.value)}
                                    type="password"
                                    isInvalid={!!errors.motDePasse}
                                />
                                <small className="text-danger">{errors.motDePasse?.message}</small>
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Je confirme mon nouveau mot de passe</Form.Label>
                                <Form.Control
                                    placeholder={!hasLabel ? '*****' : ''}
                                    value={watch('motDePasse2')}
                                    name="motDePasse2"
                                    onChange={(e) => setValue('motDePasse2', e.target.value)}
                                    type="password"
                                    isInvalid={!!errors.motDePasse2}
                                />
                                <small className="text-danger">{errors.motDePasse2?.message}</small>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group>
                        <IconButton
                            type="submit"
                            variant="outline-primary"
                            className="mt-3 mb-3 w-100"
                            icon='key'
                            disabled={!watch('motDePasse') || !watch('motDePasse2') || watch('motDePasse') != watch('motDePasse2') || isLoading}
                        >
                            Définir mon mot de passe
                        </IconButton>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    </>);
};

InitPassword.propTypes = {};

export default InitPassword;
